import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import ReportHeader2 from '../ReportHeader2'

import {
    Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'

import styles from './styles.scss'


const renderResultCell = (result) => {
    return result === "OK" ? <code className={styles.success}>{result}</code> : <code className={styles.error}>{result}</code>
}

const renderTableRow = (subTestResults) => {
    return subTestResults.map((test, idx) => {
        return (
            <TableRow key={idx}>
                <TableCell key={`errorNum${idx}`}>{test.test}</TableCell>
                <TableCell key={`warningNum${idx}`}>{test.subtest}</TableCell>
                <TableCell key={`testType${idx}`}>{test.testType}</TableCell>
                <TableCell key={`notes${idx}`}>{renderResultCell(test.notes)}</TableCell>
            </TableRow>
        )
    })
}

const renderTableHead = () => {
    return (
        <TableHead key={`head`} className={styles.tableHeader}>
            <TableCell key={`testName`}>Test</TableCell>
            <TableCell key={`errorNum`}>Subtest</TableCell>
            <TableCell key={`warningNum`}>Test Type</TableCell>
            <TableCell key={`result`}>Notes</TableCell>
        </TableHead>
    )
}

const SubtestSummary = props => {
    const subTestResults = props.subTestResults;

    return (
        <div>
            <Table selectable={false}>
                {renderTableHead()}
                {renderTableRow(subTestResults)}
            </Table>
        </div>
    )
}

SubtestSummary.propTypes = {
    subTestResults: PropTypes.array.isRequired,
}

export default CSSModules(styles)(SubtestSummary)
